import { useState } from 'react';

import Domains from '@lcsc-ui/utils/domains';
import { Image, Spin } from 'antd';

import { getInfoListByPage } from '@/apis/news';
import LcPagination from '@/components/LcPagination';
import SmallSearch from '@/components/SmallSearch';
import InfoPageRight from '@/features/infoPageRight';

function cleanEncodedString(encodedString) {
  // 替换孤立的 '%' 为合法字符
  return encodedString.replace(/%([0-9a-fA-F]{0,1})/g, '%25$1');
}

const InfoList = ({ list, keyword, pathName, tagName }) => {
  const [loading, setLoading] = useState(false);
  const [infoList, setInfoList] = useState(list);
  const [updateKw, setUpdateKw] = useState(decodeURIComponent(decodeURIComponent(cleanEncodedString(keyword))));
  const pageCb = (e) => {
    fnGetInfoList(updateKw, e);
  };
  const searchCb = (searchKeyword) => {
    setUpdateKw(searchKeyword);
    fnGetInfoList(searchKeyword, 1);
  };
  const keyWordHref = (tagKeyword) => {
    fnGetInfoList(tagKeyword, 1);
    setUpdateKw(tagKeyword);
  };
  async function fnGetInfoList(keyword, pageNum = 1) {
    setLoading(true);
    const res = await getInfoListByPage(false, pageNum, pathName, {
      pageSize: 10,
      keyword: encodeURIComponent(keyword),
    });
    setInfoList(res.result);
    setLoading(false);
  }
  return (
    <>
      <Spin spinning={loading} tip="Loading...">
        <section className="mt-[6px]">
          <div className="flex w-[1200px] m-[10px_auto_14px]">
            {/* 左边 */}
            <section className="w-[71.5%] mr-[1%] pb-[10px] ">
              <div className="mb-[16px]">
                <SmallSearch
                  size="mini"
                  placeholder={'请输入关键字搜索' + tagName}
                  className="w-full"
                  defaultValue={updateKw}
                  onSearch={(e) => searchCb(e)}
                ></SmallSearch>
              </div>
              <div className="p-[0_20px] bg-[#fff] rounded-[10px]" data-spm={infoList?.page?.currPage || 1}>
                {infoList && infoList?.industryInfoList && infoList?.industryInfoList.length > 0 ? (
                  <>
                    {infoList?.industryInfoList?.map((industryInfo, index) => (
                      <dl
                        key={index}
                        className="h-[auto] p-[20px_0] border-solid border-[#f0f0f0] border-b-[1px] last-of-type:border-none"
                      >
                        <dt className="float-left mr-[15px]">
                          {industryInfo.titleImage ? (
                            <a
                              data-spm={index + 1}
                              href={`${Domains.lcscWwwUrl}/info/${industryInfo.informationId}.html`}
                              title={industryInfo.title}
                            >
                              <Image
                                alt={industryInfo.title}
                                src={industryInfo.titleImage}
                                preview={false}
                                fallback="//static.szlcsc.com/ecp/assets/web/static/images/hyzx_p02.jpg"
                                className="w-[175px] h-[115px] rounded-[10px]"
                                width="175"
                                height="115"
                              />
                            </a>
                          ) : (
                            <a
                              data-spm={index + 1}
                              href={`${Domains.lcscWwwUrl}/info/${industryInfo.informationId}.html`}
                              title={industryInfo.title}
                            >
                              <Image
                                alt={industryInfo.title}
                                preview={false}
                                className="w-[175px] h-[115px] rounded-[10px]"
                                src="//static.szlcsc.com/ecp/assets/web/static/images/hyzx_p02.jpg"
                                width="175"
                                height="115"
                              />
                            </a>
                          )}
                        </dt>
                        <dd>
                          <a
                            data-spm={index + 1}
                            className="text-[16px] text-[#333] font-bold"
                            href={`${Domains.lcscWwwUrl}/info/${industryInfo.informationId}.html`}
                            title={industryInfo.title}
                          >
                            {industryInfo.title}
                          </a>
                        </dd>
                        <dd className="leading-[20px] m-[10px_0]">
                          <a
                            data-spm={index + 1}
                            href={`${Domains.lcscWwwUrl}/info/${industryInfo.informationId}.html`}
                            title={industryInfo.intro}
                          >
                            {industryInfo?.intro?.slice(0, 100)}
                          </a>
                          <div className="mt-[10px] text-[#999] text-[12px]">
                            <span>
                              <Image
                                alt="时间图标"
                                preview={false}
                                className="inline-block mr-[5px] w-[13px] h-[13px]"
                                src="//static.szlcsc.com/ecp/assets/web/page/activity/informationIndustryDetails/images/infolistshijian.png"
                                width="13"
                                height="13"
                              />
                              {industryInfo?.beginTime?.slice(0, 16)}
                            </span>
                            <span className="ml-[40px]">
                              <Image
                                alt="浏览数量图标"
                                preview={false}
                                className="inline-block mr-[5px] w-[15px] h-[10px]"
                                src="//static.szlcsc.com/ecp/assets/web/page/activity/informationIndustryDetails/images/infolistyll.png"
                                width="15"
                                height="10"
                              />
                              {industryInfo?.readCount}
                            </span>
                            <span className="inline ml-[40px]">
                              {industryInfo.tagRelaList && industryInfo.tagRelaList.length ? (
                                <Image
                                  alt="标签图标"
                                  preview={false}
                                  className="inline-block mr-[5px] w-[14px] h-[14px]"
                                  src="//static.szlcsc.com/ecp/assets/web/page/activity/informationIndustryDetails/images/infolistbiaoqian.png"
                                  width="14"
                                  height="14"
                                />
                              ) : null}
                              {industryInfo.tagRelaList.map((tagRela, index) => (
                                <span key={index}>
                                  {index > 0 ? <> &nbsp;|&nbsp; </> : null}
                                  <span
                                    className="text-[#0093e6] cursor-pointer"
                                    onClick={() => keyWordHref(tagRela.informationTagName)}
                                  >
                                    {tagRela.informationTagName}
                                  </span>
                                </span>
                              ))}
                            </span>
                          </div>
                        </dd>
                        <div className="clear-left"></div>
                      </dl>
                    ))}
                    <LcPagination
                      showSizeChanger={false}
                      size="small"
                      currentPage={infoList?.page?.currPage}
                      total={infoList?.page?.totalRow}
                      pageCb={pageCb}
                    />
                  </>
                ) : (
                  <div className="p-[25px_0] w-[95%] m-[0_auto] text-center text-[16px] border-b border-solid border-[#f0f0f0]">
                    {!infoList?.industryInfoList ? null : '没有查询结果！'}
                  </div>
                )}
              </div>
            </section>
            {/* 右边 */}
            <InfoPageRight infoList={infoList} />
          </div>
        </section>
      </Spin>
    </>
  );
};
export default InfoList;
